__webpack_require__.p = "https://bmidxbsouthafricaplpreprod.netlify.app/";